/**
 * Channels Grid – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

export default function ChannelsGridIcon({
  focused,
  fromMenu = false,
  margin,
  width,
  height,
}: Props & { fromMenu?: boolean; fromFloatingMenu?: boolean }) {
  const color = fromMenu
    ? Colors['menu']['icon'][focused ? 'focused' : 'unfocused']
    : Colors[focused ? 'dark' : 'light'];
  return (
    <svg
      width={(width ? width : 32) * Screen.widthRatio}
      height={(height ? height : 35) * Screen.widthRatio}
      viewBox='0 0 47 42'
      style={{ margin: margin ? margin : 0 }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='1'
        y='1'
        width='27'
        height='10'
        rx='3'
        stroke={color}
        strokeWidth={focused ? 3 : 2}
      />
      <rect
        x='1'
        y='31'
        width='27'
        height='10'
        rx='3'
        stroke={color}
        strokeWidth={focused ? 3 : 2}
      />
      <rect
        x='1'
        y='16'
        width='16'
        height='10'
        rx='3'
        stroke={color}
        strokeWidth={focused ? 3 : 2}
      />
      <rect
        x='33'
        y='1'
        width='13'
        height='10'
        rx='3'
        stroke={color}
        strokeWidth={focused ? 3 : 2}
      />
      <rect
        x='33'
        y='31'
        width='13'
        height='10'
        rx='3'
        stroke={color}
        strokeWidth={focused ? 3 : 2}
      />
      <rect
        x='22'
        y='16'
        width='24'
        height='10'
        rx='3'
        stroke={color}
        strokeWidth={focused ? 3 : 2}
      />
    </svg>
  );
}
